<div class="h1 content-title text-center p-3">Közösségi Színtér</div>

<div class="content my-5 col-lg-10 mx-auto px-5 text-center">
    <div class="the_content_wrapper">
      <p>Közösségszervező: Nagy Ilona</p>
      <p>
        További információk a programokkal, a közösségi tér rendelkezésre állásával kapcsolatban: a +36706193509 számon, kozosseg@dunaszentmiklos.hu email-címen, illetve a színtér facebook-oldalán.
      </p>
      <p>
          <a href="https://www.facebook.com/kozosseg.dunaszentmiklos"><img src="./assets/imgs/facebook.png" alt="facebook" height="30"></a>
      </p>
    </div>
</div>